import React from 'react';
import { Hero } from '../components/Hero';
import { ApplicationAreas } from '../components/ApplicationAreas';
import { Catalog } from '../components/Catalog';
import { WhyUs } from '../components/WhyUs';
import { StatsSection } from '../components/StatsSection';
import { ContactSection } from '../components/ContactSection';
import { ClientsSection } from '../components/ClientsSection';
import { PartnerSection } from '../components/PartnerSection';
import { useSEO } from '../utils/useSEO';
export function HomePage() {
  useSEO('home');
  return <div className="animate-in fade-in duration-500" data-id="element-1030">
      <Hero data-id="element-1031" />
      <ApplicationAreas data-id="element-1032" />
      <Catalog data-id="element-1033" />
      <WhyUs data-id="element-1034" />
      <StatsSection data-id="element-1035" />
      <PartnerSection data-id="element-1036" />
      <ClientsSection data-id="element-1037" />
      <ContactSection data-id="element-1038" />
    </div>;
}